import ApiClient from '@services/ApiClient';

export default class AbstractRepository {
    constructor() {
        this.params = {};
        this.apiUrl = '';
    }

    /**
     *
     * @param fieldKey
     * @returns {AbstractRepository}
     */
    orderBy(fieldKey) {
        this.params['f_params[orderBy][field]'] = fieldKey;
        return this;
    }

    /**
     *
     * @param direction
     * @returns {AbstractRepository}
     */
    orderDirection(direction) {
        if (direction !== 'DESC' && direction !== 'ASC') {
            throw new Error('Direction needs to be either DESC or ASC');
        }

        this.params['f_params[orderBy][type]'] = direction;
        return this;
    }

    /**
     *
     * @param field
     * @param value
     * @returns {AbstractRepository}
     */
    where(field, value) {
        if (value !== null && value !== undefined) {
            this.params[field] = value;
        }
        return this;
    }

    /**
     *
     * @param field
     * @param value
     * @returns {AbstractRepository}
     */
    orWhere(field, value) {
        if (value !== null && value !== undefined) {
            if (!this.params.or) {
                this.params.or = [];
            }

            this.params.or.push({ field, value });
        }
        return this;
    }

    /**
     *
     * @param field
     * @param values
     * @returns {AbstractRepository}
     */
    whereIn(field, values) {
        values.forEach((value) => {
            if (value !== null && value !== undefined) {
                if (!this.params.whereIn) {
                    this.params.whereIn = [];
                }
                this.params.whereIn.push({
                    value,
                    field,
                });
            }
        });
        return this;
    }

    /**
     *
     * @param field
     * @param start
     * @param end
     * @returns {AbstractRepository}
     */
    whereBetween(field, start, end) {
        if (start !== null) {
            this.params[`${field}[start]`] = start;
        }
        if (end !== null) {
            this.params[`${field}[end]`] = end;
        }
        return this;
    }

    /**
     *
     * @param field
     * @param value
     * @returns {AbstractRepository}
     */
    whereLike(field, value) {
        if (value !== null && value !== undefined) {
            this.params[`${field}[like]`] = value;
        }
        return this;
    }

    /**
     *
     * @param field
     * @param operator
     * @param value
     * @returns {AbstractRepository}
     */
    whereByOperator(field, operator, value) {
        if (!['!', '<', '>', '='].includes(operator)) {
            throw new Error('Unknown operator');
        }

        if (value !== null && value !== undefined) {
            this.params[`${field}[operator]`] = operator;
            this.params[`${field}[value]`] = value;
        }

        return this;
    }

    /**
     *
     * @returns {string}
     */
    generateParams() {
        const qs = Object.keys(this.params)
            .map((key) => {
                if (key === 'whereIn') {
                    return this.params.whereIn.map((item) => `${item.field}[]=${item.value}`).join('&');
                }

                if (key === 'or') {
                    return this.params.or.map((item) => `or[${item.field}][]=${item.value}`).join('&');
                }

                return `${key}=${this.params[key]}`;
            })
            .join('&');

        return encodeURI(`${this.apiUrl}?${qs}`);
    }

    /**
     *
     * @returns {AbstractRepository}
     */
    resetParams() {
        this.params = {};
        return this;
    }

    /**
     *
     * @param url
     * @returns {AbstractRepository}
     */
    setApiUrl(url) {
        this.apiUrl = url;
        return this;
    }

    /**
     *
     * @param value
     * @returns {AbstractRepository}
     */
    setCurrentPage(value) {
        this.params.page = value || 1;
        return this;
    }

    /**
     *
     * @param value
     * @returns {AbstractRepository}
     */
    setPerPage(value) {
        this.params.perpage = value || 50;
        return this;
    }

    /**
     *
     * @returns {Promise<any|null>}
     */
    async run() {
        const params = this.generateParams();
        this.resetParams();
        const res = await ApiClient.get(params);
        return res.data || null;
    }

    createFromBootstrapContext(ctx) {
        let request = this
            .setPerPage(ctx.perPage)
            .setCurrentPage(ctx.currentPage);

        if (ctx.sortBy && ctx.sortBy !== '') {
            request = request.orderBy(ctx.sortBy).orderDirection(ctx.sortDesc ? 'DESC' : 'ASC');
        }

        if (ctx.filter.search) {
            request = request.where('search', ctx.filter.search);
        }

        return request;
    }
}
